export const responseType = {
    arraybuffer: 'arraybuffer',
    blob: 'blob',
    json: 'json',
    text: 'text'
}
